import React from "react";
import EditUserRequestMenu from "../components/menu/admin/EditUserRequestMenu";

const RequestEditUser = () => {
  return <EditUserRequestMenu />;
};
export default RequestEditUser;
